import { render, staticRenderFns } from "./KefuDialog.vue?vue&type=template&id=5987680c&scoped=true"
import script from "./KefuDialog.vue?vue&type=script&lang=js"
export * from "./KefuDialog.vue?vue&type=script&lang=js"
import style0 from "./KefuDialog.vue?vue&type=style&index=0&id=5987680c&prod&lang=scss&scoped=true"
import style1 from "./KefuDialog.vue?vue&type=style&index=1&id=5987680c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5987680c",
  null
  
)

export default component.exports